export class DepInformationsForm {
  assureNom?: string;
  assurePrenom?: string;
  assureAdresse?: string;
  caisse?: string;
  assureSituation?:
    | 'activite_salarie'
    | 'activite_non_salarie'
    | 'sans_emploi'
    | 'pensionne'
    | 'autre';
  assureSansEmploiDate?: Date;
  assureAutreDetail?: string;
  accident?: boolean;
  accidentDate?: Date;
  pensionneDeGuerre?: boolean;
  lienAvecLAssure?:
    | 'conjoint'
    | 'enfant'
    | 'autre_membre_famille'
    | 'personne_vivant_maritalement_avec_l_assure';
  activiteProfessionnelleOuPension?: boolean;
  aldSurListe?: boolean;
  aldHorsListe?: boolean;
  oxygenotherapieParConcentrateur?: boolean;
  oxygenotherapieParConcentrateurPosteFixe?: boolean;
  oxygenotherapieParConcentrateurDeambulation?: boolean;
  oxygenotherapieParConcentrateurDuree?: number;
  oxygenotherapieParConcentrateurDebit?: number;
  oxygenotherapieGazeuseParBouteille?: boolean;
  oxygenotherapieGazeuseParBouteillePosteFixe?: boolean;
  oxygenotherapieGazeuseParBouteilleDeambulation?: boolean;
  oxygenotherapieGazeuseParBouteilleDuree?: number;
  oxygenotherapieGazeuseParBouteilleDebit?: number;
  oxygenotherapieLiquide?: boolean;
  oxygenotherapieLiquidePosteFixe?: boolean;
  oxygenotherapieLiquideDeambulation?: boolean;
  oxygenotherapieLiquideDuree?: number;
  oxygenotherapieLiquideDebit?: number;
  ventilationMecaniqueALemboutBuccal?: boolean;
  ventilationMecaniqueALemboutBuccalDuree?: number;
  ventilationMecaniqueALemboutBuccalDebit?: number;
  ventilationMecaniqueParMasqueNasal?: boolean;
  ventilationMecaniqueParMasqueNasalDuree?: number;
  ventilationMecaniqueParMasqueNasalDebit?: number;
  ventilationMecaniqueParTracheotomie?: boolean;
  ventilationMecaniqueParTracheotomieDuree?: number;
  ventilationMecaniqueParTracheotomieDebit?: number;
  ventilationMecaniqueParProtheseExtraThoracique?: boolean;
  ventilationMecaniqueParProtheseExtraThoraciqueDuree?: number;
  ventilationMecaniqueParProtheseExtraThoraciqueDebit?: number;
  ventilationMecaniqueParPpc?: boolean;
  ventilationMecaniqueParPpcDuree?: number;
  ventilationMecaniqueParPpcDebit?: number;
  aspirationSansVentilationSurTracheotomie?: boolean;
  autres?: boolean;
  autresDetail?: string;
  appareillagePrescrit?: 'a_l_acte' | 'association';
  associationNom?: string;
  associationAdresse?: string;
  associationForfaitSoinsNumero?: string;
  concentrateurMarque?: string;
  concentrateurType?: string;
  respirateurMarque?: string;
  respirateurType?: string;
  materielO2LiquideMarque?: string;
  materielO2LiquideType?: string;
  autresMarque?: string;
  autresType?: string;
  prescripteurType?: 'pneumologue' | 'reanimateur' | 'generaliste' | 'autre';
  prescripteurTypeAutreDetail?: string;
  bronchiteChroniquePrincipale?: boolean;
  bronchiteChroniqueSecondaire?: boolean;
  lesionsMutilantesPostTuberculeusesPrincipale?: boolean;
  lesionsMutilantesPostTuberculeusesSecondaire?: boolean;
  asthmeADyspneeContinuePrincipale?: boolean;
  asthmeADyspneeContinueSecondaire?: boolean;
  fibrosesEtProcessusInterstitielsPrincipale?: boolean;
  fibrosesEtProcessusInterstitielsSecondaire?: boolean;
  cyphoScoliosePrincipale?: boolean;
  cyphoScolioseSecondaire?: boolean;
  emphysemePrimitifPrincipale?: boolean;
  emphysemePrimitifSecondaire?: boolean;
  dilatationsEtenduesDesBronchesPrincipale?: boolean;
  dilatationsEtenduesDesBronchesSecondaire?: boolean;
  myopathiesPrincipale?: boolean;
  myopathiesSecondaire?: boolean;
  autresAtteintesNeuroMusculairesPrincipale?: boolean;
  autresAtteintesNeuroMusculairesSecondaire?: boolean;
  pneumoconiosesPrincipale?: boolean;
  pneumoconiosesSecondaire?: boolean;
  apneesDuSommeilPrincipale?: boolean;
  apneesDuSommeilSecondaire?: boolean;
  mucoviscidosePrincipale?: boolean;
  mucoviscidoseSecondaire?: boolean;
  dysplasieBronchoPulmonaireDuNourrissonPrincipale?: boolean;
  dysplasieBronchoPulmonaireDuNourrissonSecondaire?: boolean;
  autrePrincipale?: boolean;
  autreSecondaire?: boolean;
  autreDetail?: string;
  tabac?: 'jamais' | 'ne_fume_plus' | 'fume';
  antecedentIvd?: boolean;
  ivdActuelle?: boolean;
  spirographieDate?: Date;
  spirographiePoids?: number;
  spirographieTaille?: number;
  spirographieCapaciteVitale?: number;
  spirographieCapaciteTotale?: number;
  spirographieVems?: number;
  gazDuSangArteriel?: 'kpa' | 'mmhg';
  reposEnAirMesure1Date?: Date;
  reposEnAirMesure1Ph?: number;
  reposEnAirMesure1Paco2?: number;
  reposEnAirMesure1Pao2?: number;
  reposEnAirMesure2Date?: Date;
  reposEnAirMesure2Ph?: number;
  reposEnAirMesure2Paco2?: number;
  reposEnAirMesure2Pao2?: number;
  reposSousO2EtOuVentilationDate?: Date;
  reposSousO2EtOuVentilationPh?: number;
  reposSousO2EtOuVentilationPaco2?: number;
  reposSousO2EtOuVentilationPao2?: number;
  aLEffortEnAirDate?: Date;
  aLEffortEnAirPh?: number;
  aLEffortEnAirPaco2?: number;
  aLEffortEnAirPao2?: number;
  aLEffortEnAirSao2?: number;
  hematocrite?: number;
  casParticuliers?: string;

  constructor(
    assureNom?: string,
    assurePrenom?: string,
    assureAdresse?: string,
    caisse?: string,
    assureSituation?:
      | 'activite_salarie'
      | 'activite_non_salarie'
      | 'sans_emploi'
      | 'pensionne'
      | 'autre',
    assureSansEmploiDate?: Date,
    assureAutreDetail?: string,
    accident?: boolean,
    accidentDate?: Date,
    pensionneDeGuerre?: boolean,
    lienAvecLAssure?:
      | 'conjoint'
      | 'enfant'
      | 'autre_membre_famille'
      | 'personne_vivant_maritalement_avec_l_assure',
    activiteProfessionnelleOuPension?: boolean,
    prescripteurType?: 'pneumologue' | 'reanimateur' | 'generaliste' | 'autre',
    prescripteurTypeAutreDetail?: string,
    aldSurListe?: boolean,
    aldHorsListe?: boolean,
    oxygenotherapieParConcentrateur?: boolean,
    oxygenotherapieParConcentrateurPosteFixe?: boolean,
    oxygenotherapieParConcentrateurDeambulation?: boolean,
    oxygenotherapieParConcentrateurDuree?: number,
    oxygenotherapieParConcentrateurDebit?: number,
    oxygenotherapieGazeuseParBouteille?: boolean,
    oxygenotherapieGazeuseParBouteillePosteFixe?: boolean,
    oxygenotherapieGazeuseParBouteilleDeambulation?: boolean,
    oxygenotherapieGazeuseParBouteilleDuree?: number,
    oxygenotherapieGazeuseParBouteilleDebit?: number,
    oxygenotherapieLiquide?: boolean,
    oxygenotherapieLiquidePosteFixe?: boolean,
    oxygenotherapieLiquideDeambulation?: boolean,
    oxygenotherapieLiquideDuree?: number,
    oxygenotherapieLiquideDebit?: number,
    ventilationMecaniqueALemboutBuccal?: boolean,
    ventilationMecaniqueALemboutBuccalDuree?: number,
    ventilationMecaniqueALemboutBuccalDebit?: number,
    ventilationMecaniqueParMasqueNasal?: boolean,
    ventilationMecaniqueParMasqueNasalDuree?: number,
    ventilationMecaniqueParMasqueNasalDebit?: number,
    ventilationMecaniqueParTracheotomie?: boolean,
    ventilationMecaniqueParTracheotomieDuree?: number,
    ventilationMecaniqueParTracheotomieDebit?: number,
    ventilationMecaniqueParProtheseExtraThoracique?: boolean,
    ventilationMecaniqueParProtheseExtraThoraciqueDuree?: number,
    ventilationMecaniqueParProtheseExtraThoraciqueDebit?: number,
    ventilationMecaniqueParPpc?: boolean,
    ventilationMecaniqueParPpcDuree?: number,
    ventilationMecaniqueParPpcDebit?: number,
    aspirationSansVentilationSurTracheotomie?: boolean,
    autres?: boolean,
    autresDetail?: string,
    appareillagePrescrit?: 'a_l_acte' | 'association',
    associationNom?: string,
    associationAdresse?: string,
    associationForfaitSoinsNumero?: string,
    concentrateurMarque?: string,
    concentrateurType?: string,
    respirateurMarque?: string,
    respirateurType?: string,
    materielO2LiquideMarque?: string,
    materielO2LiquideType?: string,
    autresMarque?: string,
    autresType?: string,
    bronchiteChroniquePrincipale?: boolean,
    bronchiteChroniqueSecondaire?: boolean,
    lesionsMutilantesPostTuberculeusesPrincipale?: boolean,
    lesionsMutilantesPostTuberculeusesSecondaire?: boolean,
    asthmeADyspneeContinuePrincipale?: boolean,
    asthmeADyspneeContinueSecondaire?: boolean,
    fibrosesEtProcessusInterstitielsPrincipale?: boolean,
    fibrosesEtProcessusInterstitielsSecondaire?: boolean,
    cyphoScoliosePrincipale?: boolean,
    cyphoScolioseSecondaire?: boolean,
    emphysemePrimitifPrincipale?: boolean,
    emphysemePrimitifSecondaire?: boolean,
    dilatationsEtenduesDesBronchesPrincipale?: boolean,
    dilatationsEtenduesDesBronchesSecondaire?: boolean,
    myopathiesPrincipale?: boolean,
    myopathiesSecondaire?: boolean,
    autresAtteintesNeuroMusculairesPrincipale?: boolean,
    autresAtteintesNeuroMusculairesSecondaire?: boolean,
    pneumoconiosesPrincipale?: boolean,
    pneumoconiosesSecondaire?: boolean,
    apneesDuSommeilPrincipale?: boolean,
    apneesDuSommeilSecondaire?: boolean,
    mucoviscidosePrincipale?: boolean,
    mucoviscidoseSecondaire?: boolean,
    dysplasieBronchoPulmonaireDuNourrissonPrincipale?: boolean,
    dysplasieBronchoPulmonaireDuNourrissonSecondaire?: boolean,
    autrePrincipale?: boolean,
    autreSecondaire?: boolean,
    autreDetail?: string,
    tabac?: 'jamais' | 'ne_fume_plus' | 'fume',
    antecedentIvd?: boolean,
    ivdActuelle?: boolean,
    spirographieDate?: Date,
    spirographiePoids?: number,
    spirographieTaille?: number,
    spirographieCapaciteVitale?: number,
    spirographieCapaciteTotale?: number,
    spirographieVems?: number,
    gazDuSangArteriel?: 'kpa' | 'mmhg',
    reposEnAirMesure1Date?: Date,
    reposEnAirMesure1Ph?: number,
    reposEnAirMesure1Paco2?: number,
    reposEnAirMesure1Pao2?: number,
    reposEnAirMesure2Date?: Date,
    reposEnAirMesure2Ph?: number,
    reposEnAirMesure2Paco2?: number,
    reposEnAirMesure2Pao2?: number,
    reposSousO2EtOuVentilationDate?: Date,
    reposSousO2EtOuVentilationPh?: number,
    reposSousO2EtOuVentilationPaco2?: number,
    reposSousO2EtOuVentilationPao2?: number,
    aLEffortEnAirDate?: Date,
    aLEffortEnAirPh?: number,
    aLEffortEnAirPaco2?: number,
    aLEffortEnAirPao2?: number,
    aLEffortEnAirSao2?: number,
    hematocrite?: number,
    casParticuliers?: string,
  ) {
    this.assureNom = assureNom;
    this.assurePrenom = assurePrenom;
    this.assureAdresse = assureAdresse;
    this.caisse = caisse;
    this.assureSituation = assureSituation;
    this.assureSansEmploiDate = assureSansEmploiDate;
    this.assureAutreDetail = assureAutreDetail;
    this.accident = accident;
    this.accidentDate = accidentDate;
    this.pensionneDeGuerre = pensionneDeGuerre;
    this.lienAvecLAssure = lienAvecLAssure;
    this.activiteProfessionnelleOuPension = activiteProfessionnelleOuPension;
    this.aldSurListe = aldSurListe;
    this.aldHorsListe = aldHorsListe;
    this.oxygenotherapieParConcentrateur = oxygenotherapieParConcentrateur;
    this.oxygenotherapieParConcentrateurPosteFixe =
      oxygenotherapieParConcentrateurPosteFixe;
    this.oxygenotherapieParConcentrateurDeambulation =
      oxygenotherapieParConcentrateurDeambulation;
    this.oxygenotherapieParConcentrateurDuree =
      oxygenotherapieParConcentrateurDuree;
    this.oxygenotherapieParConcentrateurDebit =
      oxygenotherapieParConcentrateurDebit;
    this.oxygenotherapieGazeuseParBouteille =
      oxygenotherapieGazeuseParBouteille;
    this.oxygenotherapieGazeuseParBouteillePosteFixe =
      oxygenotherapieGazeuseParBouteillePosteFixe;
    this.oxygenotherapieGazeuseParBouteilleDeambulation =
      oxygenotherapieGazeuseParBouteilleDeambulation;
    this.oxygenotherapieGazeuseParBouteilleDuree =
      oxygenotherapieGazeuseParBouteilleDuree;
    this.oxygenotherapieGazeuseParBouteilleDebit =
      oxygenotherapieGazeuseParBouteilleDebit;
    this.oxygenotherapieLiquide = oxygenotherapieLiquide;
    this.oxygenotherapieLiquidePosteFixe = oxygenotherapieLiquidePosteFixe;
    this.oxygenotherapieLiquideDeambulation =
      oxygenotherapieLiquideDeambulation;
    this.oxygenotherapieLiquideDuree = oxygenotherapieLiquideDuree;
    this.oxygenotherapieLiquideDebit = oxygenotherapieLiquideDebit;
    this.ventilationMecaniqueALemboutBuccal =
      ventilationMecaniqueALemboutBuccal;
    this.ventilationMecaniqueALemboutBuccalDuree =
      ventilationMecaniqueALemboutBuccalDuree;
    this.ventilationMecaniqueALemboutBuccalDebit =
      ventilationMecaniqueALemboutBuccalDebit;
    this.ventilationMecaniqueParMasqueNasal =
      ventilationMecaniqueParMasqueNasal;
    this.ventilationMecaniqueParMasqueNasalDuree =
      ventilationMecaniqueParMasqueNasalDuree;
    this.ventilationMecaniqueParMasqueNasalDebit =
      ventilationMecaniqueParMasqueNasalDebit;
    this.ventilationMecaniqueParTracheotomie =
      ventilationMecaniqueParTracheotomie;
    this.ventilationMecaniqueParTracheotomieDuree =
      ventilationMecaniqueParTracheotomieDuree;
    this.ventilationMecaniqueParTracheotomieDebit =
      ventilationMecaniqueParTracheotomieDebit;
    this.ventilationMecaniqueParProtheseExtraThoracique =
      ventilationMecaniqueParProtheseExtraThoracique;
    this.ventilationMecaniqueParProtheseExtraThoraciqueDuree =
      ventilationMecaniqueParProtheseExtraThoraciqueDuree;
    this.ventilationMecaniqueParProtheseExtraThoraciqueDebit =
      ventilationMecaniqueParProtheseExtraThoraciqueDebit;
    this.ventilationMecaniqueParPpc = ventilationMecaniqueParPpc;
    this.ventilationMecaniqueParPpcDuree = ventilationMecaniqueParPpcDuree;
    this.ventilationMecaniqueParPpcDebit = ventilationMecaniqueParPpcDebit;
    this.aspirationSansVentilationSurTracheotomie =
      aspirationSansVentilationSurTracheotomie;
    this.autres = autres;
    this.autresDetail = autresDetail;
    this.appareillagePrescrit = appareillagePrescrit;
    this.associationNom = associationNom;
    this.associationAdresse = associationAdresse;
    this.associationForfaitSoinsNumero = associationForfaitSoinsNumero;
    this.concentrateurMarque = concentrateurMarque;
    this.concentrateurType = concentrateurType;
    this.respirateurMarque = respirateurMarque;
    this.respirateurType = respirateurType;
    this.materielO2LiquideMarque = materielO2LiquideMarque;
    this.materielO2LiquideType = materielO2LiquideType;
    this.autresMarque = autresMarque;
    this.autresType = autresType;
    this.prescripteurType = prescripteurType;
    this.prescripteurTypeAutreDetail = prescripteurTypeAutreDetail;
    this.bronchiteChroniquePrincipale = bronchiteChroniquePrincipale;
    this.bronchiteChroniqueSecondaire = bronchiteChroniqueSecondaire;
    this.lesionsMutilantesPostTuberculeusesPrincipale =
      lesionsMutilantesPostTuberculeusesPrincipale;
    this.lesionsMutilantesPostTuberculeusesSecondaire =
      lesionsMutilantesPostTuberculeusesSecondaire;
    this.asthmeADyspneeContinuePrincipale = asthmeADyspneeContinuePrincipale;
    this.asthmeADyspneeContinueSecondaire = asthmeADyspneeContinueSecondaire;
    this.fibrosesEtProcessusInterstitielsPrincipale =
      fibrosesEtProcessusInterstitielsPrincipale;
    this.fibrosesEtProcessusInterstitielsSecondaire =
      fibrosesEtProcessusInterstitielsSecondaire;
    this.cyphoScoliosePrincipale = cyphoScoliosePrincipale;
    this.cyphoScolioseSecondaire = cyphoScolioseSecondaire;
    this.emphysemePrimitifPrincipale = emphysemePrimitifPrincipale;
    this.emphysemePrimitifSecondaire = emphysemePrimitifSecondaire;
    this.dilatationsEtenduesDesBronchesPrincipale =
      dilatationsEtenduesDesBronchesPrincipale;
    this.dilatationsEtenduesDesBronchesSecondaire =
      dilatationsEtenduesDesBronchesSecondaire;
    this.myopathiesPrincipale = myopathiesPrincipale;
    this.myopathiesSecondaire = myopathiesSecondaire;
    this.autresAtteintesNeuroMusculairesPrincipale =
      autresAtteintesNeuroMusculairesPrincipale;
    this.autresAtteintesNeuroMusculairesSecondaire =
      autresAtteintesNeuroMusculairesSecondaire;
    this.pneumoconiosesPrincipale = pneumoconiosesPrincipale;
    this.pneumoconiosesSecondaire = pneumoconiosesSecondaire;
    this.apneesDuSommeilPrincipale = apneesDuSommeilPrincipale;
    this.apneesDuSommeilSecondaire = apneesDuSommeilSecondaire;
    this.mucoviscidosePrincipale = mucoviscidosePrincipale;
    this.mucoviscidoseSecondaire = mucoviscidoseSecondaire;
    this.dysplasieBronchoPulmonaireDuNourrissonPrincipale =
      dysplasieBronchoPulmonaireDuNourrissonPrincipale;
    this.dysplasieBronchoPulmonaireDuNourrissonSecondaire =
      dysplasieBronchoPulmonaireDuNourrissonSecondaire;
    this.autrePrincipale = autrePrincipale;
    this.autreSecondaire = autreSecondaire;
    this.autreDetail = autreDetail;
    this.tabac = tabac;
    this.antecedentIvd = antecedentIvd;
    this.ivdActuelle = ivdActuelle;
    this.spirographieDate = spirographieDate;
    this.spirographiePoids = spirographiePoids;
    this.spirographieTaille = spirographieTaille;
    this.spirographieCapaciteVitale = spirographieCapaciteVitale;
    this.spirographieCapaciteTotale = spirographieCapaciteTotale;
    this.spirographieVems = spirographieVems;
    this.gazDuSangArteriel = gazDuSangArteriel;
    this.reposEnAirMesure1Date = reposEnAirMesure1Date;
    this.reposEnAirMesure1Ph = reposEnAirMesure1Ph;
    this.reposEnAirMesure1Paco2 = reposEnAirMesure1Paco2;
    this.reposEnAirMesure1Pao2 = reposEnAirMesure1Pao2;
    this.reposEnAirMesure2Date = reposEnAirMesure2Date;
    this.reposEnAirMesure2Ph = reposEnAirMesure2Ph;
    this.reposEnAirMesure2Paco2 = reposEnAirMesure2Paco2;
    this.reposEnAirMesure2Pao2 = reposEnAirMesure2Pao2;
    this.reposSousO2EtOuVentilationDate = reposSousO2EtOuVentilationDate;
    this.reposSousO2EtOuVentilationPh = reposSousO2EtOuVentilationPh;
    this.reposSousO2EtOuVentilationPaco2 = reposSousO2EtOuVentilationPaco2;
    this.reposSousO2EtOuVentilationPao2 = reposSousO2EtOuVentilationPao2;
    this.aLEffortEnAirDate = aLEffortEnAirDate;
    this.aLEffortEnAirPh = aLEffortEnAirPh;
    this.aLEffortEnAirPaco2 = aLEffortEnAirPaco2;
    this.aLEffortEnAirPao2 = aLEffortEnAirPao2;
    this.aLEffortEnAirSao2 = aLEffortEnAirSao2;
    this.hematocrite = hematocrite;
    this.casParticuliers = casParticuliers;
  }

  toAPI(): DepInformationsFormAPI {
    return {
      assure_nom: this.assureNom,
      assure_prenom: this.assurePrenom,
      assure_adresse: this.assureAdresse,
      caisse: this.caisse,
      assure_situation: this.assureSituation,
      assure_sans_emploi_date: this.assureSansEmploiDate
        ? this.assureSansEmploiDate.toISOString()
        : undefined,
      assure_autre_detail: this.assureAutreDetail,
      accident: this.accident,
      accident_date: this.accidentDate
        ? this.accidentDate.toISOString()
        : undefined,
      pensionne_de_guerre: this.pensionneDeGuerre,
      lien_avec_l_assure: this.lienAvecLAssure,
      activite_professionnelle_ou_pension:
        this.activiteProfessionnelleOuPension,
      ald_sur_liste: this.aldSurListe,
      ald_hors_liste: this.aldHorsListe,
      oxygenotherapie_par_concentrateur: this.oxygenotherapieParConcentrateur,
      oxygenotherapie_par_concentrateur_poste_fixe:
        this.oxygenotherapieParConcentrateurPosteFixe,
      oxygenotherapie_par_concentrateur_deambulation:
        this.oxygenotherapieParConcentrateurDeambulation,
      oxygenotherapie_par_concentrateur_duree:
        this.oxygenotherapieParConcentrateurDuree,
      oxygenotherapie_par_concentrateur_debit:
        this.oxygenotherapieParConcentrateurDebit,
      oxygenotherapie_gazeuse_par_bouteille:
        this.oxygenotherapieGazeuseParBouteille,
      oxygenotherapie_gazeuse_par_bouteille_poste_fixe:
        this.oxygenotherapieGazeuseParBouteillePosteFixe,
      oxygenotherapie_gazeuse_par_bouteille_deambulation:
        this.oxygenotherapieGazeuseParBouteilleDeambulation,
      oxygenotherapie_gazeuse_par_bouteille_duree:
        this.oxygenotherapieGazeuseParBouteilleDuree,
      oxygenotherapie_gazeuse_par_bouteille_debit:
        this.oxygenotherapieGazeuseParBouteilleDebit,
      oxygenotherapie_liquide: this.oxygenotherapieLiquide,
      oxygenotherapie_liquide_poste_fixe: this.oxygenotherapieLiquidePosteFixe,
      oxygenotherapie_liquide_deambulation:
        this.oxygenotherapieLiquideDeambulation,
      oxygenotherapie_liquide_duree: this.oxygenotherapieLiquideDuree,
      oxygenotherapie_liquide_debit: this.oxygenotherapieLiquideDebit,
      ventilation_mecanique_a_l_embout_buccal:
        this.ventilationMecaniqueALemboutBuccal,
      ventilation_mecanique_a_l_embout_buccal_duree:
        this.ventilationMecaniqueALemboutBuccalDuree,
      ventilation_mecanique_a_l_embout_buccal_debit:
        this.ventilationMecaniqueALemboutBuccalDebit,
      ventilation_mecanique_par_masque_nasal:
        this.ventilationMecaniqueParMasqueNasal,
      ventilation_mecanique_par_masque_nasal_duree:
        this.ventilationMecaniqueParMasqueNasalDuree,
      ventilation_mecanique_par_masque_nasal_debit:
        this.ventilationMecaniqueParMasqueNasalDebit,
      ventilation_mecanique_par_tracheotomie:
        this.ventilationMecaniqueParTracheotomie,
      ventilation_mecanique_par_tracheotomie_duree:
        this.ventilationMecaniqueParTracheotomieDuree,
      ventilation_mecanique_par_tracheotomie_debit:
        this.ventilationMecaniqueParTracheotomieDebit,
      ventilation_mecanique_par_prothese_extra_thoracique:
        this.ventilationMecaniqueParProtheseExtraThoracique,
      ventilation_mecanique_par_prothese_extra_thoracique_duree:
        this.ventilationMecaniqueParProtheseExtraThoraciqueDuree,
      ventilation_mecanique_par_prothese_extra_thoracique_debit:
        this.ventilationMecaniqueParProtheseExtraThoraciqueDebit,
      ventilation_mecanique_par_ppc: this.ventilationMecaniqueParPpc,
      ventilation_mecanique_par_ppc_duree: this.ventilationMecaniqueParPpcDuree,
      ventilation_mecanique_par_ppc_debit: this.ventilationMecaniqueParPpcDebit,
      aspiration_sans_ventilation_sur_tracheotomie:
        this.aspirationSansVentilationSurTracheotomie,
      autres: this.autres,
      autres_detail: this.autresDetail,
      appareillage_prescrit: this.appareillagePrescrit,
      association_nom: this.associationNom,
      association_adresse: this.associationAdresse,
      association_forfait_soins_numero: this.associationForfaitSoinsNumero,
      concentrateur_marque: this.concentrateurMarque,
      concentrateur_type: this.concentrateurType,
      respirateur_marque: this.respirateurMarque,
      respirateur_type: this.respirateurType,
      materiel_O2_liquide_marque: this.materielO2LiquideMarque,
      materiel_O2_liquide_type: this.materielO2LiquideType,
      autres_marque: this.autresMarque,
      autres_type: this.autresType,
      prescripteur_type: this.prescripteurType,
      prescripteur_type_autre_detail: this.prescripteurTypeAutreDetail,
      bronchite_chronique_principale: this.bronchiteChroniquePrincipale,
      bronchite_chronique_secondaire: this.bronchiteChroniqueSecondaire,
      lesions_mutilantes_post_tuberculeuses_principale:
        this.lesionsMutilantesPostTuberculeusesPrincipale,
      lesions_mutilantes_post_tuberculeuses_secondaire:
        this.lesionsMutilantesPostTuberculeusesSecondaire,
      asthme_a_dyspnee_continue_principale:
        this.asthmeADyspneeContinuePrincipale,
      asthme_a_dyspnee_continue_secondaire:
        this.asthmeADyspneeContinueSecondaire,
      fibroses_et_processus_interstitiels_principale:
        this.fibrosesEtProcessusInterstitielsPrincipale,
      fibroses_et_processus_interstitiels_secondaire:
        this.fibrosesEtProcessusInterstitielsSecondaire,
      cypho_scoliose_principale: this.cyphoScoliosePrincipale,
      cypho_scoliose_secondaire: this.cyphoScolioseSecondaire,
      emphyseme_primitif_principale: this.emphysemePrimitifPrincipale,
      emphyseme_primitif_secondaire: this.emphysemePrimitifSecondaire,
      dilatations_etendues_des_bronches_principale:
        this.dilatationsEtenduesDesBronchesPrincipale,
      dilatations_etendues_des_bronches_secondaire:
        this.dilatationsEtenduesDesBronchesSecondaire,
      myopathies_principale: this.myopathiesPrincipale,
      myopathies_secondaire: this.myopathiesSecondaire,
      autres_atteintes_neuro_musculaires_principale:
        this.autresAtteintesNeuroMusculairesPrincipale,
      autres_atteintes_neuro_musculaires_secondaire:
        this.autresAtteintesNeuroMusculairesSecondaire,
      pneumoconioses_principale: this.pneumoconiosesPrincipale,
      pneumoconioses_secondaire: this.pneumoconiosesSecondaire,
      apnees_du_sommeil_principale: this.apneesDuSommeilPrincipale,
      apnees_du_sommeil_secondaire: this.apneesDuSommeilSecondaire,
      mucoviscidose_principale: this.mucoviscidosePrincipale,
      mucoviscidose_secondaire: this.mucoviscidoseSecondaire,
      dysplasie_broncho_pulmonaire_du_nourrisson_principale:
        this.dysplasieBronchoPulmonaireDuNourrissonPrincipale,
      dysplasie_broncho_pulmonaire_du_nourrisson_secondaire:
        this.dysplasieBronchoPulmonaireDuNourrissonSecondaire,
      autre_principale: this.autrePrincipale,
      autre_secondaire: this.autreSecondaire,
      autre_detail: this.autreDetail,
      tabac: this.tabac,
      antecedent_ivd: this.antecedentIvd,
      ivd_actuelle: this.ivdActuelle,
      spirographie_date: this.spirographieDate
        ? this.spirographieDate.toISOString()
        : undefined,
      spirographie_poids: this.spirographiePoids,
      spirographie_taille: this.spirographieTaille,
      spirographie_capacite_vitale: this.spirographieCapaciteVitale,
      spirographie_capacite_totale: this.spirographieCapaciteTotale,
      spirographie_vems: this.spirographieVems,
      gaz_du_sang_arteriel: this.gazDuSangArteriel,
      repos_en_air_mesure_1_date: this.reposEnAirMesure1Date
        ? this.reposEnAirMesure1Date.toISOString()
        : undefined,
      repos_en_air_mesure_1_ph: this.reposEnAirMesure1Ph,
      repos_en_air_mesure_1_paco2: this.reposEnAirMesure1Paco2,
      repos_en_air_mesure_1_pao2: this.reposEnAirMesure1Pao2,
      repos_en_air_mesure_2_date: this.reposEnAirMesure2Date
        ? this.reposEnAirMesure2Date.toISOString()
        : undefined,
      repos_en_air_mesure_2_ph: this.reposEnAirMesure2Ph,
      repos_en_air_mesure_2_paco2: this.reposEnAirMesure2Paco2,
      repos_en_air_mesure_2_pao2: this.reposEnAirMesure2Pao2,
      repos_sous_o2_et_ou_ventilation_date: this.reposSousO2EtOuVentilationDate
        ? this.reposSousO2EtOuVentilationDate.toISOString()
        : undefined,
      repos_sous_o2_et_ou_ventilation_ph: this.reposSousO2EtOuVentilationPh,
      repos_sous_o2_et_ou_ventilation_paco2:
        this.reposSousO2EtOuVentilationPaco2,
      repos_sous_o2_et_ou_ventilation_pao2: this.reposSousO2EtOuVentilationPao2,
      a_l_effort_en_air_date: this.aLEffortEnAirDate
        ? this.aLEffortEnAirDate.toISOString()
        : undefined,
      a_l_effort_en_air_ph: this.aLEffortEnAirPh,
      a_l_effort_en_air_paco2: this.aLEffortEnAirPaco2,
      a_l_effort_en_air_pao2: this.aLEffortEnAirPao2,
      a_l_effort_en_air_sao2: this.aLEffortEnAirSao2,
      hematocrite: this.hematocrite,
      cas_particuliers: this.casParticuliers,
    };
  }
}

export type DepInformationsFormAPI = {
  assure_nom?: string;
  assure_prenom?: string;
  assure_adresse?: string;
  caisse?: string;
  assure_situation?:
    | 'activite_salarie'
    | 'activite_non_salarie'
    | 'sans_emploi'
    | 'pensionne'
    | 'autre';
  assure_sans_emploi_date?: string;
  assure_autre_detail?: string;
  accident?: boolean;
  accident_date?: string;
  pensionne_de_guerre?: boolean;
  lien_avec_l_assure?:
    | 'conjoint'
    | 'enfant'
    | 'autre_membre_famille'
    | 'personne_vivant_maritalement_avec_l_assure';
  activite_professionnelle_ou_pension?: boolean;
  ald_sur_liste?: boolean;
  ald_hors_liste?: boolean;
  oxygenotherapie_par_concentrateur?: boolean;
  oxygenotherapie_par_concentrateur_poste_fixe?: boolean;
  oxygenotherapie_par_concentrateur_deambulation?: boolean;
  oxygenotherapie_par_concentrateur_duree?: number;
  oxygenotherapie_par_concentrateur_debit?: number;
  oxygenotherapie_gazeuse_par_bouteille?: boolean;
  oxygenotherapie_gazeuse_par_bouteille_poste_fixe?: boolean;
  oxygenotherapie_gazeuse_par_bouteille_deambulation?: boolean;
  oxygenotherapie_gazeuse_par_bouteille_duree?: number;
  oxygenotherapie_gazeuse_par_bouteille_debit?: number;
  oxygenotherapie_liquide?: boolean;
  oxygenotherapie_liquide_poste_fixe?: boolean;
  oxygenotherapie_liquide_deambulation?: boolean;
  oxygenotherapie_liquide_duree?: number;
  oxygenotherapie_liquide_debit?: number;
  ventilation_mecanique_a_l_embout_buccal?: boolean;
  ventilation_mecanique_a_l_embout_buccal_duree?: number;
  ventilation_mecanique_a_l_embout_buccal_debit?: number;
  ventilation_mecanique_par_masque_nasal?: boolean;
  ventilation_mecanique_par_masque_nasal_duree?: number;
  ventilation_mecanique_par_masque_nasal_debit?: number;
  ventilation_mecanique_par_tracheotomie?: boolean;
  ventilation_mecanique_par_tracheotomie_duree?: number;
  ventilation_mecanique_par_tracheotomie_debit?: number;
  ventilation_mecanique_par_prothese_extra_thoracique?: boolean;
  ventilation_mecanique_par_prothese_extra_thoracique_duree?: number;
  ventilation_mecanique_par_prothese_extra_thoracique_debit?: number;
  ventilation_mecanique_par_ppc?: boolean;
  ventilation_mecanique_par_ppc_duree?: number;
  ventilation_mecanique_par_ppc_debit?: number;
  aspiration_sans_ventilation_sur_tracheotomie?: boolean;
  autres?: boolean;
  autres_detail?: string;
  appareillage_prescrit?: 'a_l_acte' | 'association';
  association_nom?: string;
  association_adresse?: string;
  association_forfait_soins_numero?: string;
  concentrateur_marque?: string;
  concentrateur_type?: string;
  respirateur_marque?: string;
  respirateur_type?: string;
  materiel_O2_liquide_marque?: string;
  materiel_O2_liquide_type?: string;
  autres_marque?: string;
  autres_type?: string;
  prescripteur_type?: 'pneumologue' | 'reanimateur' | 'generaliste' | 'autre';
  prescripteur_type_autre_detail?: string;
  bronchite_chronique_principale?: boolean;
  bronchite_chronique_secondaire?: boolean;
  lesions_mutilantes_post_tuberculeuses_principale?: boolean;
  lesions_mutilantes_post_tuberculeuses_secondaire?: boolean;
  asthme_a_dyspnee_continue_principale?: boolean;
  asthme_a_dyspnee_continue_secondaire?: boolean;
  fibroses_et_processus_interstitiels_principale?: boolean;
  fibroses_et_processus_interstitiels_secondaire?: boolean;
  cypho_scoliose_principale?: boolean;
  cypho_scoliose_secondaire?: boolean;
  emphyseme_primitif_principale?: boolean;
  emphyseme_primitif_secondaire?: boolean;
  dilatations_etendues_des_bronches_principale?: boolean;
  dilatations_etendues_des_bronches_secondaire?: boolean;
  myopathies_principale?: boolean;
  myopathies_secondaire?: boolean;
  autres_atteintes_neuro_musculaires_principale?: boolean;
  autres_atteintes_neuro_musculaires_secondaire?: boolean;
  pneumoconioses_principale?: boolean;
  pneumoconioses_secondaire?: boolean;
  apnees_du_sommeil_principale?: boolean;
  apnees_du_sommeil_secondaire?: boolean;
  mucoviscidose_principale?: boolean;
  mucoviscidose_secondaire?: boolean;
  dysplasie_broncho_pulmonaire_du_nourrisson_principale?: boolean;
  dysplasie_broncho_pulmonaire_du_nourrisson_secondaire?: boolean;
  autre_principale?: boolean;
  autre_secondaire?: boolean;
  autre_detail?: string;
  tabac?: 'jamais' | 'ne_fume_plus' | 'fume';
  antecedent_ivd?: boolean;
  ivd_actuelle?: boolean;
  spirographie_date?: string;
  spirographie_poids?: number;
  spirographie_taille?: number;
  spirographie_capacite_vitale?: number;
  spirographie_capacite_totale?: number;
  spirographie_vems?: number;
  gaz_du_sang_arteriel?: 'kpa' | 'mmhg';
  repos_en_air_mesure_1_date?: string;
  repos_en_air_mesure_1_ph?: number;
  repos_en_air_mesure_1_paco2?: number;
  repos_en_air_mesure_1_pao2?: number;
  repos_en_air_mesure_2_date?: string;
  repos_en_air_mesure_2_ph?: number;
  repos_en_air_mesure_2_paco2?: number;
  repos_en_air_mesure_2_pao2?: number;
  repos_sous_o2_et_ou_ventilation_date?: string;
  repos_sous_o2_et_ou_ventilation_ph?: number;
  repos_sous_o2_et_ou_ventilation_paco2?: number;
  repos_sous_o2_et_ou_ventilation_pao2?: number;
  a_l_effort_en_air_date?: string;
  a_l_effort_en_air_ph?: number;
  a_l_effort_en_air_paco2?: number;
  a_l_effort_en_air_pao2?: number;
  a_l_effort_en_air_sao2?: number;
  hematocrite?: number;
  cas_particuliers?: string;
};
